
import rootReducer from './reducers';
import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools,devToolsEnhancer, actionCreators } from 'redux-devtools-extension';

// Inline thunk middleware — byte-for-byte identical to
// redux-thunk@3.1.0's createThunkMiddleware(). Inlined because the
// npm package ships its CJS entry as a `.cjs` file; Jest 24 (bundled
// with react-scripts 3.x) routes anything not ending in
// .js/.jsx/.ts/.tsx/.css/.json through its `fileTransform`, which
// returns a filename string instead of the module — so `thunk` came
// back undefined at test time -> "middleware is not a function" ->
// pre-push smoke suite failed at src/store.js. Middleware is 3
// lines; inlining removes the whole dependency-resolution class of
// bugs while preserving behaviour (kept the withExtraArgument shape
// available should we need it later).
const thunk = ({ dispatch, getState }) => (next) => (action) =>
  typeof action === 'function' ? action(dispatch, getState) : next(action);



const composeEnhancers = composeWithDevTools({ actionCreators, trace: true });


const store = createStore(rootReducer, composeEnhancers(applyMiddleware(thunk)));



export default store;
